export default __webpack_public_path__ + "static/media/planet-neptune-internal.3ebd623e.svg";